
export default {
name: 'moreFutureDevelopment',
components: {

},
data () {
return {

}
},
methods: {
myCollect () {
this.$router.push({
path: '/myCollect'
})
}
},
created () {

},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/views/moreFutureDevelopment/script.js